import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { EditSquare } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { formatLicensePlate } from '../../../../utils/string';
import { AddressFields } from '../../../Address/components/AddressFields';
import { selectWorks } from '../../../Api/selectors';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { completeVehicleTransport, deleteVehicleProperty, setVehicleProperty } from '../../../Vehicles/actions';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { refreshBoards } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { BaseCellComp } from '../BaseCellComp';
import { Cell } from '../Cell';
import { TransportAssignableOptions, TransportAssignableSortMap } from './Transport_1_nl_in';
import { REQUEST_COMPANIES_PROPERTY } from '../../../Companies/constants';
import { selectCompanyProperty } from '../../../Companies/selectors';
import { selectAddress } from '../../../Address/selectors';
import { REQUEST_ADDRESSES_BY_IDS } from '../../../Address/constants';

const Container = styled.div`
  .modal-inner {
    margin-bottom: 120px;
  }

  .regplate {
    font-size: 14px;
  }

  p {
    margin: 0;
  }

  .col-regplate-vin {
    max-width: 200px;
  }

  .col-model-info {
    min-width: 100px;
    max-width: 100px;
  }

  .col-address-from {
    min-width: 250px;
    max-width: 250px;
  }

  .col-address-to {
    min-width: 200px;
    max-width: 200px;
  }

  .col-status {
    min-width: 200px;
    max-width: 200px;
  }
  .info-block {
    white-space: nowrap;
  }

  font-size: 12px;
`;

const STATE = {
  approve: false,
  loading: false,
  confirmReset: false,
};

/* eslint-disable react/prefer-stateless-function */
class IDWE_transport_out_individualComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  static transportAssignableSortMap = TransportAssignableSortMap;

  renderApprove() {
    if (!this.state.approve) return null;
    if (!this.vehicle) return '...';
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('kanbanboards.cell.IDWE_transport_out_individual.modal.title')}>
        {this.renderBody()}
      </Modal>
    );
  }

  renderBody() {
    const vehicle = this.vehicle;

    if (this.props.work || this.state.loading)
      return (
        <HBox center>
          <Loader small />
        </HBox>
      );
    return (
      <>
        <HBox center vCenter>
          <row>
            <VBox vCenter>
              <VBox className="regplate col-regplate-vin">
                <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
                <span style={{ opacity: 0.4 }}>{vehicle.vin || ''}</span>
              </VBox>
              <VBox className="col-model-info">
                <p style={{ fontWeight: 600 }}>{vehicle.brand_name}</p>
                <p>{vehicle.model_name}</p>
              </VBox>
              <VBox className="address col-address-from">
                <CompanyLabelById
                  fetchName
                  transportCard
                  transport_to={vehicle?.transport_individual_from_company_name}
                  company_id={vehicle?.transport_individual_from_company_id}
                />
                <AddressFields inlineshort addressId={vehicle.transport_individual_from_address_id} />
                <div className="mb-1">
                  <CompanyLabelById fetchPhone company_id={vehicle.transport_individual_from_company_id} />
                </div>
              </VBox>
              <VBox className="address col-address-to"></VBox>
              <VehicleStatusLabel>
                {TransportAssignableOptions.find(
                  dto => dto.value == this.vehicle.transport_individual_assigned_to,
                )?.label?.replace(/\_/g, ' ')}
              </VehicleStatusLabel>
            </VBox>
          </row>
          {this.state.confirmReset ? (
            <VBox center>
              <div>{this.lbl('reset')}?</div>
              <HBox>
                <Button
                  onClick={() => {
                    this.setState({ loading: true });
                    this.props.resetTransport(() => {
                      this.reset();
                    });
                  }}
                >
                  {this.lbl('confirm')}
                </Button>
                <Button onClick={this.setStateFn({ confirmReset: false })}>{this.lbl('cancel')}</Button>
              </HBox>
            </VBox>
          ) : (
            <Button onClick={this.setStateFn({ confirmReset: true })}>
              <EditSquare />
              {this.lbl('reset')}
            </Button>
          )}
        </HBox>
        <ModalControls>
          {this.props.work ? (
            <Loader small />
          ) : (
            <>
              <Button onClick={() => this.props.done(this.reset.bind(this))}>{this.lbl('complete')}</Button>
              <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
            </>
          )}
        </ModalControls>
      </>
    );
  }

  render() {
    const vehicle = this.vehicle;

    return (
      <Cell>
        <Container onClick={this.setStateFn({ approve: !this.state.approve })}>
          {this.props.cell.busy ? <Loader small /> : null}
          <HBox vCenter className="info-block">
            <VBox left className="regplate col-regplate-vin">
              <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
              <span style={{ opacity: 0.4 }}>{vehicle.vin || ''}</span>
            </VBox>
            <VBox left className="col-model-info">
              <p style={{ fontWeight: 600 }}>{vehicle.brand_name}</p>
              <p>{vehicle.model_name}</p>
            </VBox>
            <VBox left className="address col-address-from">
              {this.props.fromCompanyName && (
                <CompanyLabelById
                  fetchName
                  transportCard
                  transport_to={vehicle?.transport_individual_from_company_name}
                  company_id={vehicle?.transport_individual_from_company_id}
                />
              )}
              {this.props.fromAddress && (
                <AddressFields inlineshort addressId={vehicle.transport_individual_from_address_id} />
              )}
              <div className="mb-1">
                <CompanyLabelById fetchPhone company_id={vehicle.transport_individual_from_company_id} />
              </div>
            </VBox>
            <VBox left className="address col-address-to">
              {this.props.toCompanyName && (
                <CompanyLabelById
                  fetchName
                  transportCard
                  transport_to={vehicle?.transport_individual_to_company_name}
                  company_id={vehicle.transport_individual_to_company_id}
                />
              )}
              {this.props.toAddress && <AddressFields inlineshort addressId={vehicle.transport_individual_to_address_id} />}
            </VBox>
            <VBox className="col-status">
              <HBox vCenter left autoWidth>
                <VehicleStatusLabel>
                  {TransportAssignableOptions.find(
                    dto => dto.value == this.vehicle.transport_individual_assigned_to,
                  )?.label?.replace(/\_/g, ' ')}
                </VehicleStatusLabel>
              </HBox>
            </VBox>
          </HBox>
        </Container>
        {this.renderApprove()}
        <HBox style={{ fontSize: '12px' }} onClick={this.tofn(`/vehicles/${vehicle.id}`)}>
          {vehicle.id}{' '}
        </HBox>
      </Cell>
    );
  }
}

IDWE_transport_out_individualComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_COMPANIES_PROPERTY,
      REQUEST_ADDRESSES_BY_IDS,
    ]),
    fromCompanyName: selectCompanyProperty(ownProps.cell.vehicle.transport_individual_from_company_id, 'name'),
    toCompanyName: selectCompanyProperty(ownProps.cell.vehicle.transport_individual_to_company_id, 'name'),
    fromAddress: selectAddress(ownProps.cell.vehicle.transport_individual_from_address_id),
    toAddress: selectAddress(ownProps.cell.vehicle.transport_individual_to_address_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    // Declare resetTransport as an async function
    async resetTransport(callback) {
      try {
        let id = ownProps.cell.vehicle.id;

        // Delete the 'transport_outgoing_assigned_to' property
        await dispatch(deleteVehicleProperty(id, 'transport_individual_assigned_to'));

        // Delete the 'transport_outgoing_initiated' property
        await dispatch(deleteVehicleProperty(id, 'transport_individual_initiated'));

        // Set the 'transport_outgoing_deleted' property to '1'
        await dispatch(setVehicleProperty(id, 'transport_individual_deleted', '1'));

        // Refresh the boards
        await dispatch(refreshBoards());

        // Execute the callback
        callback();
      } catch (error) {
        console.error('Error resetting transport:', error);
      }
    },

    done(callback) {
      let id = ownProps.cell.vehicle.id;
      const action_name = ownProps.action.functionName;
      dispatch(
        completeVehicleTransport(id, false, true, action_name, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const IDWE_transport_out_individual = compose(withConnect, withRouter)(IDWE_transport_out_individualComp);
